import React from "react";
import { getStatusColor } from "./utils";

const StatusBadge = ({ status }) => {
  return (
    <span
      className={`px-2 py-1 text-xs rounded-full border whitespace-nowrap flex-shrink-0 ${getStatusColor(
        status
      )}`}
      role="status"
      aria-label={`Status: ${status || "Unknown"}`}
    >
      {status || "Unknown"}
    </span>
  );
};

export default StatusBadge;
